import React, { Component } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import Receipt from '../../../../../assets/images/module/general/ReceiptDummy.png';
import { Row, Col, Form, Tooltip, OverlayTrigger } from 'react-bootstrap';
import CustomModal from '.';
import { showNotification } from '@mantine/notifications';
import ColorButton from '../Buttons/ColorButton';
import CopyIcon from '../../../SVGs/copyIcon';
import GreenTick from '../../../../../assets/images/module/general/GreenTick.svg';
import { Checkbox, Group, Stack, TextInput } from '@mantine/core';
import EmptyStateContainer from '../EmptyStateContainer/EmptyStateContainer';
import TenantIconBlue from '../../../../../assets/images/module/general/TenantIconBlue.svg';
import { NumericFormat } from 'react-number-format';

const MOBILE_SIZE = 992;
const TABLET_SIZE = 1200;

export class AutoAssignReceiptTenantTransaction extends Component {
  state = {
    isMobile: window.innerWidth <= MOBILE_SIZE,
    isTablet: window.innerWidth <= TABLET_SIZE
  };
  
  constructor(props) {
    super(props);
  }
  
  render() {
    const { open, toggle, className, update, mappings, addNewReceiptTenantTransaction, renderMappingData, selectedTransaction, textQualifierRules } = this.props;
    
    return (
      <CustomModal
        heading={'Regel gefunden'}
        headingClassName={'update-received-rent-modal-heading'}
        open={open}
        toggle={() => {
          toggle();
        }}
        className={`${className}`}
      >
        <Stack>
            <Group>
              {textQualifierRules ?
              <span style={{fontFamily: 'Inter, sans-serif', fontWeight: '400'}}>Für diese Zahlung wurden folgende Regeln gefunden:</span>
              :
              <span style={{fontFamily: 'Inter, sans-serif', fontWeight: '400'}}>Für diese Zahlung <span style={{fontWeight: 'bold'}}>{`(${selectedTransaction?.counterpartIban} / ${selectedTransaction?.counterpartName})`}</span> wurden automatische Regeln gefunden:</span>}
            </Group>
            {textQualifierRules ?
            <Stack gap={8}>
              {renderMappingData()}
            </Stack>
            :
            <Group>
              {renderMappingData()}
            </Group>}
            <Group>
              <span style={{fontFamily: 'Inter, sans-serif', fontWeight: '400'}}>Wollen Sie die Regeln jetzt auf diese Transaction anwenden?</span>
            </Group>
            <Group justify="space-between">
                <div>
                    <ColorButton
                    text={'Abbrechen'}
                    className='gray-btn'
                    onClick={()=> toggle()}
                    />
                </div>
                <div>
                    <ColorButton
                    text={'Anwenden'}
                    className='purple-btn'
                    onClick={()=> addNewReceiptTenantTransaction()}
                    />
                </div>
            </Group>
        </Stack>
      </CustomModal>
    );
  }
}

export default AutoAssignReceiptTenantTransaction;
